import "@digirati/canvas-panel-web-components";
import { useLocalization as T, ResourceUnavailable as x, ImageResponsive as K, ListingCarousel as $, useAlignImagesToBase as ee, GuiButton as P, GuiInput as G, Icon as B, useEventBus as te, CopyButton as ae, DelimitedFieldValues as ne, GuiLink as F, RichText as ie } from "@thegetty-private/getty-ui";
import { extractImageUuid as U } from "@thegetty-private/linked-data.js";
import { resolveComponent as c, openBlock as r, createElementBlock as d, renderSlot as z, createElementVNode as f, createVNode as m, createBlock as b, resolveDynamicComponent as j, mergeProps as R, withCtx as y, createTextVNode as k, toDisplayString as C, Fragment as q, useTemplateRef as le, createSlots as W, normalizeProps as se, guardReactiveProps as oe, normalizeClass as M, createCommentVNode as g, Transition as _, renderList as S, markRaw as re, ref as Z, computed as p, normalizeStyle as H, Teleport as ue } from "vue";
const ce = "rightsstatements.org/vocab/NoC-US/1.0/", de = "rightsstatements.org/vocab/InC/1.0/", he = "rightsstatements.org/vocab/CNE/1.0/", me = "rightsstatements.org/vocab/InC-RUU/1.0/", fe = "rightsstatements.org/vocab/UND/1.0/", ge = "creativecommons.org/publicdomain/zero/1.0/", I = {
  NO_COPYRIGHT: ce,
  IN_COPYRIGHT: de,
  NOT_EVALUATED: he,
  IN_COPYRIGHT_UNIDENTIFIABLE: me,
  UNDETERMINED: fe,
  ZERO: ge
};
function N(e, t = "en", a = " ", l = "label") {
  if (!e[l])
    return;
  const i = Object.keys(e[l]);
  let n = i.indexOf(t) != -1 ? i.indexOf(t) : 0;
  return e[l][i[n]].join(a);
}
function O(e) {
  let t;
  return e.type == "Canvas" && (t = e.id), e.type == "Image" && (t = e.service[0].id || e.service[0]["@id"]), e.type == "Annotation" && (t = e.body[0].id), t;
}
function be(e) {
  let t = {}, a = e.reduce((l, i) => {
    let n = Object.keys(i).filter((o) => !l.includes(o));
    return l.concat(n);
  }, []);
  for (let l of a)
    e.forEach((i) => {
      t[l] ? t[l] = t[l].concat(i[l]) : t[l] = i[l];
    });
  return t;
}
function ye(e) {
  const t = e.rights ? e.rights.split("//")[1] : void 0;
  return t && [
    I.IN_COPYRIGHT,
    I.IN_COPYRIGHT_UNIDENTIFIABLE
  ].includes(t);
}
function ve(e, t, a, l) {
  const i = t ? `${t[0]},` : "full", n = `${U(e, l)}_${(t == null ? void 0 : t[0]) ?? "full"}.jpg`;
  return `${e}/full/${i}/0/default.jpg?download=${n}&size=${a}`;
}
const Y = {
  name: "ViewerSupport",
  emits: [
    "thumbnailsReady",
    "zoom",
    "ready",
    "worldReady",
    "fullscreenchange",
    "hasActiveMenu",
    "togglePaged"
  ],
  props: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * the order index of the canvas in the manifest
     */
    canvasIndex: {
      type: Number,
      default: void 0
    },
    /**
     * Whether to override the default thumbnails from the manifest with full canvases
     */
    useCanvasThumbnails: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether in fullscreen or not
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * Option for parent to provide canvas id to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Object for providing optional additional data to image derived from visual item (also accepts canvas uuid)
     * { 	"https://media.getty.edu/iiif/image/b3c4fb26-04de-4ac8-9df7-f020f4f97a51":
     *    {
     *      isZoomable: false,
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      altText: 'alt text',
     *      descriptiveNote: 'description',
     *      rightsStatementId: 'rightsstatement.org url,
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *    }
     * }
     */
    imageMetadata: {
      type: Object,
      default: () => ({})
    },
    /**
     * A delimiting string for parsing uuids from non-Getty IIIF image services
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both
     */
    labelSource: {
      type: String,
      default: "default",
      validator: (e) => ["default", "range", "all"].includes(e)
    }
  },
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      locale: this.$i18n.locale ?? "en",
      /* Current manifest in vault */
      manifest: void 0,
      /**
       * Current choices
       * { choice_id: [ choice_object, choice_object] }
       */
      currentChoices: {},
      /**
       * Have display annotations for choices been added?
       */
      displayAnnotationsAdded: !1,
      /**
       * Fetch manifest status error
       */
      errorMessage: void 0,
      /**
       * Stored x/y coords on a mousedown event in order to detect zoom
       */
      clickCoords: {}
    };
  },
  watch: {
    async manifestUrl() {
      await this.loadManifest();
    },
    /**
     * Enter/exit fullscreen based on prop
     */
    isFullscreen(e) {
      e == !0 && (this.$el.requestFullscreen || this.$el.webkitRequestFullscreen).call(
        this.$el
      ), document.fullscreenElement && e == !1 && document.exitFullscreen();
    }
  },
  computed: {
    /**
     * Returns the canvas id of the image (selected) to be displayed in the viewer (canvas panel only)
     *
     * @return {string} canvas id
     * */
    currentCanvasId() {
      var e;
      if ((e = this.manifest) != null && e.items)
        return this.canvasId ? this.canvasId : this.manifest.items[0].id;
    }
  },
  methods: {
    /**
     * Loads the manifest into vault
     */
    async loadManifest() {
      var e;
      if (this.$el) {
        let t = this.$el.vault.get(this.manifestUrl);
        if (t && ["Collection", "Dataset"].includes(t == null ? void 0 : t.type) && (this.manifest = this.$el.vault.get({
          id: this.manifestUrl,
          type: "Manifest"
        })), !this.manifest) {
          const a = await this.fetchManifest(this.manifestUrl);
          this.manifest = await ((e = this.$el.vault) == null ? void 0 : e.loadManifest(
            this.manifestUrl,
            a
          ));
        }
        this.getThumbnails(), this.canvasTitle = this.buildCanvasTitle();
      }
    },
    /**
     * Fetches the manifest json and updates error message
     *
     * @param {string} - manifest url
     * @returns {object|undefined} manifest json
     */
    async fetchManifest(e) {
      const t = await fetch(e);
      let a;
      if (t.status == 200)
        a = await t.json();
      else {
        let l = `${t.status} ${t.statusText}`;
        this.errorMessage = this.translatePart("m-image-viewer.error_message", {
          status: l
        });
      }
      return a;
    },
    /**
     * Returns either alt text provided by parent through additional image data
     * or canvas label property
     *
     * @param {Object} canvas - IIIF Canvas
     * @returns {String} alt text string
     */
    getAltText(e) {
      const t = this.getVisualItem(e), a = this.getImageServiceRef(e);
      return (t == null ? void 0 : t.altText) || this.getLabel(a, this.locale);
    },
    /**
     * Filters an array of IIIF Annotation based on if the annotation body refers to a choice
     *
     * @param {Array} annotations - Array IIF Annotation objects
     * @returns {Array} - IIF Annotation objects
     */
    getChoiceAnnotations(e) {
      return e.filter((a) => this.$el.vault.get(a.body[0].id).type == "Choice");
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     * @emits {zoom}
     *
     */
    handleZoom(e) {
      this.$emit("zoom", e);
    },
    /**
     * Handle Ready event
     * @param {event} e - the ready event
     */
    handleReady(e) {
      this.$emit("ready", e), this.manifest || this.loadManifest();
    },
    /**
     * Handle World Ready event
     * @param {event} e - the world-ready event
     */
    handleWorldReady(e) {
      this.$emit("worldReady", e), this.handleZoom(e);
    },
    /**
     * Add display annotations based on annotations that contain choices
     */
    async setChoiceDisplayAnnotations() {
      let e = await this.$el.vault.getState().iiif.entities.Annotation;
      e = Object.values(e);
      const t = this.getChoiceAnnotations(e);
      for (let a of t)
        this.addChoiceDisplayAnnotation(a);
    },
    /**
     * Adds display annotation for a choice to the panel
     *
     * @param {object} - vault choice annotation object
     */
    async addChoiceDisplayAnnotation(e) {
      const t = this.$el.createAnnotationDisplay(e);
      t.className = `m-image-viewer__choice--${e.body[0].id}`;
      let a = await this.$el.vault.get(e.body[0].id), l = await this.$el.vault.get(a.items[0].id), i = this.getLabel(l);
      i && (t.title = i), this.$el.annotations.add(t);
    },
    /**
     * Handle click events, handle clicking on display annotations
     *
     * @deprecated not in use with switch to zoom events on single click - DEV-17753
     *
     * @param {event} e - double-click event
     */
    handleDblClick(e) {
      const t = e.composedPath()[0];
      let l = Array.from(t.classList).pop();
      if (l && l.startsWith("m-image-viewer__choice")) {
        const i = l.split("--").pop();
        let n = JSON.parse(JSON.stringify(this.currentChoices)), o = n[i].items[1], s = o.selected;
        this.$el.makeChoice(o.id, {
          deselect: s,
          deselectOthers: s
        }), n[i].items.forEach((u) => {
          u.selected = !u.selected;
        }), this.currentChoices = n;
      }
    },
    /**
     * Handle click events, enable mouse control of zoom buttons and account for pan/drag
     *
     * @param {event} e - click event
     */
    clickHandler(e) {
      if (["CANVAS-PANEL", "SEQUENCE-PANEL"].includes(e.target.tagName) && (e.type == "mousedown" && (this.clickCoords = { x: e.x, y: e.y }), e.type == "mouseup" && e.button == 0)) {
        if (this.clickCoords.x != e.x || this.clickCoords.y != e.y)
          return;
        e.metaKey ? this.$el.zoomOut() : this.$el.zoomIn();
      }
    },
    /**
     * Update current choices on choice event
     *
     * @param {event} e - choice event
     */
    handleChoice(e) {
      var t;
      if (((t = e.detail.choice) == null ? void 0 : t.type) == "single-choice") {
        let a = e.detail.choice.partOf.choiceId;
        this.currentChoices[a] = {
          ...e.detail.choice,
          // make sure selected is first in the array
          items: e.detail.choice.items.sort((l) => l.selected ? -1 : 1)
        };
      }
    },
    /**
     * Handler for native fullscreenchange events, like esc to exit fullscreen
     *
     * @param {event} e - fullscreenchange event
     */
    handleNativeFullscreenChange(e) {
      this.isFullscreen && document.fullscreenElement == null && this.$emit("fullscreenchange", e);
    },
    /**
     * On context menu event (right-click), check whether to prevent menu from displaying
     * @param {e} - context menu event
     */
    handleContextMenu(e) {
      if (e.target.tagName == "CANVAS-PANEL" && this.currentCanvasId) {
        const t = this.$el.vault.get(this.currentCanvasId);
        this.getDisableContextMenu(t) && e.preventDefault();
      }
      e.target.tagName == "SEQUENCE-PANEL" && this.currentSequence && this.currentSequence.map(
        (a) => this.$el.vault.get(this.$el.sequence.items[a].id)
      ).some((a) => ye(a)) && e.preventDefault();
    },
    /**
     * Returns the IIIF Range/Structure that includes the supplied canvas id
     *
     * @param {String} canvasId - Valid canvas id
     * @returns {Object|undefined} - IIIF structure
     */
    getRangeByCanvasId(e) {
      let t = [];
      const a = Object.values(
        this.$el.vault.getState().iiif.entities.Range
      );
      return a && (t = a.filter(
        (l) => l.items && l.items.find((i) => i.id == e)
      )), t[0];
    },
    /**
     * Transforms array of canvases to expected object for thumbnailProps computed prop transform
     *
     * @param {Array} canvases - Array of IIIF canvases
     * @param {string} labelSource - Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both if they are available
     *
     *
     * @returns {Object} Canvas Ids mapped to IIIF thumbnail or image content resource objects (or canvases if flagged)
     */
    mapCanvasesToThumbnails(e, t) {
      let a = {};
      return this.$el.vault.get(e).forEach((l) => {
        let i = this.getImageServiceRef(l), n = O(i);
        if (i.label || (i.label = l.label), this.useCanvasThumbnails)
          a[n] = i;
        else {
          const o = this.getRangeByCanvasId(l.id);
          if (t == "range" && (o != null && o.label) && (i.label = o.label), t == "all" && (o != null && o.label) && (i.concatLabel = be([
            i.label,
            o.label
          ])), i.type == "Image" && (a[n] = i), i.type == "Annotation") {
            const s = i.body[0].id;
            a[n] = {
              id: s,
              label: l.label,
              type: "Image"
            };
          }
          a[n].canvasId = l.id;
        }
      }), a;
    },
    /**
     * Gets the correct locale label from IIIF content resource
     *
     * @param {Object} resource - IIIF Content Resource object
     * @param {String} locale - ISO language string
     * @returns {String} - concatenated label for display
     */
    getLabel(e) {
      return N(e, this.locale);
    },
    /**
     * Returns the resource that refers to an image service from a canvas
     * @param {object} - IIIF canvas
     *
     * @return {object} - thumbnail, annotation, or defaults to canvas object
     */
    getImageServiceRef(e) {
      var a;
      let t;
      if (this.useCanvasThumbnails)
        t = e;
      else if (e.thumbnail && e.thumbnail.length)
        t = this.$el.vault.get(e.thumbnail[0]);
      else if (e.items && e.items.length) {
        let l = this.$el.vault.get(e.items[0].id);
        t = this.$el.vault.get(((a = l == null ? void 0 : l.items) == null ? void 0 : a[0]) ?? {}) ?? e;
      }
      return JSON.parse(JSON.stringify(t));
    },
    /**
     * Returns whether to disable context menu (right-click) based on canvas
     *
     * @param {Object} canvas - IIIF Canvas
     * @returns {boolean} whether to disable the context menu
     */
    getDisableContextMenu(e) {
      const t = this.getVisualItem(e);
      return (t == null ? void 0 : t.disableContextMenu) === !0;
    },
    /**
     * Returns the image metadata entry derived from the visual item if provided
     * @param {object} canvas - IIIF Canvas
     * @returns {object|undefined}
     */
    getVisualItem(e) {
      const t = this.getImageServiceRef(e), a = O(t);
      return this.imageMetadata[a] || this.imageMetadata[e.id];
    }
  }
}, v = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [l, i] of t)
    a[l] = i;
  return a;
}, Ce = {
  name: "CanvasViewer",
  components: { ResourceUnavailable: x },
  mixins: [Y],
  props: {
    /**
     * Whether or not the current canvas is zoomable
     */
    isZoomable: {
      type: Boolean,
      default: !0
    },
    /**
     * Degrees of rotation to apply to the canvas
     */
    rotation: {
      type: Number,
      default: 0
    }
  },
  emits: ["thumbnailsReady"],
  data() {
    return {
      canvasTitle: void 0
    };
  },
  watch: {
    /**
     * @fixme Do we need this
     */
    useCanvasThumbnails() {
      this.getThumbnails();
    }
  },
  methods: {
    /**
     * Handles the change in canvas
     *
     * @param {e} - the canvas change event
     */
    handleCurrentCanvas(e) {
      var t, a;
      if (this.currentChoices = {}, (t = e.detail) != null && t.canvas) {
        const l = this.$el.vault.get(e.detail.canvas), i = this.getImageServiceRef(l), n = O(i), o = this.$el.vault.get(n);
        let s = n, u, h = (a = o == null ? void 0 : o.service) == null ? void 0 : a[0];
        h && (u = h == null ? void 0 : h.sizes, s = h.id ?? s), e.detail.image = n, e.detail.canvasDetails = {
          width: l.width,
          height: l.height,
          serviceUrl: s,
          sizes: u
        };
      }
    },
    /**
     * Gets thumbnails from manifest items
     *
     * @emits("thumbnailsReady")
     */
    getThumbnails() {
      var e;
      if (this.manifest) {
        let t = ((e = this.manifest) == null ? void 0 : e.items) ?? [];
        const a = this.mapCanvasesToThumbnails(
          t,
          this.labelSource
        );
        this.$emit("thumbnailsReady", a);
      }
    },
    /**
     * A title for the HTML canvas
     * @return {string | undefined }
     */
    buildCanvasTitle() {
      if (this.currentCanvasId)
        return this.getAltText(this.$el.vault.get(this.currentCanvasId));
    }
  }
}, we = ["manifest-id", "canvas-id", "preset", "a11y-title", "rotation"], pe = {
  slot: "fallback",
  class: "m-image-viewer__error"
};
function Ae(e, t, a, l, i, n) {
  const o = c("ResourceUnavailable");
  return r(), d("canvas-panel", {
    key: e.currentCanvasId,
    "manifest-id": e.manifestUrl,
    "canvas-id": e.currentCanvasId,
    preset: a.isZoomable ? "zoom" : "static",
    "a11y-role": "img",
    "a11y-title": i.canvasTitle,
    rotation: a.rotation,
    onReadyOnce: t[0] || (t[0] = (...s) => e.handleReady && e.handleReady(...s)),
    onWorldReady: t[1] || (t[1] = (...s) => e.handleWorldReady && e.handleWorldReady(...s)),
    onZoom: t[2] || (t[2] = (...s) => e.handleZoom && e.handleZoom(...s)),
    onCanvasChange: t[3] || (t[3] = (...s) => n.handleCurrentCanvas && n.handleCurrentCanvas(...s)),
    onMousedown: t[4] || (t[4] = (...s) => e.clickHandler && e.clickHandler(...s)),
    onMouseup: t[5] || (t[5] = (...s) => e.clickHandler && e.clickHandler(...s)),
    onChoice: t[6] || (t[6] = (...s) => e.handleChoice && e.handleChoice(...s)),
    onFullscreenchange: t[7] || (t[7] = (...s) => e.handleNativeFullscreenChange && e.handleNativeFullscreenChange(...s)),
    onContextmenu: t[8] || (t[8] = (...s) => e.handleContextMenu && e.handleContextMenu(...s))
  }, [
    z(e.$slots, "controls", { currentChoices: e.currentChoices }),
    f("div", pe, [
      m(o, { "caption-text": e.errorMessage }, null, 8, ["caption-text"])
    ])
  ], 40, we);
}
const Ie = /* @__PURE__ */ v(Ce, [["render", Ae]]), Te = {
  name: "SequenceViewer",
  components: { ResourceUnavailable: x },
  mixins: [Y],
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer"
    },
    /* Current range id for ranges */
    rangeId: {
      type: String,
      default: void 0
    },
    /* Component type */
    componentType: {
      type: String,
      default: void 0
    },
    /* Whether or not to show gallery view */
    showGallery: {
      type: Boolean,
      default: !1
    },
    /* The layout type of the viewer */
    viewerLayout: {
      type: String,
      default: void 0
    }
  },
  emits: ["thumbnailsReady"],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      /* Gutter between facing pages */
      sequenceMargin: 100,
      /* Item indexes of the current sequence */
      currentSequence: [],
      /**
       * the current position in the sequence
       */
      sequencePosition: 0,
      /**
       * the total # of items in the sequence
       */
      sequenceLength: 0,
      /**
       * The title for the HTML canvas
       */
      canvasTitle: void 0,
      /**
       * The label for the HTML canvas for the facing pages view
       */
      facingPagesLabel: this.translate(
        this.baseLocaleKey + ".alt_text.facing_pages"
      ),
      /**
       * The label for the HTML canvas for choices
       */
      choiceLabel: this.translate(this.baseLocaleKey + ".alt_text.choice")
    };
  },
  computed: {
    /* Initialize range id if undefined for viewing ranges */
    rangeId_() {
      var t, a;
      let e = this.rangeId;
      return this.componentType == "range" && !this.rangeId && (e = (a = (t = this.manifest) == null ? void 0 : t.structures[0]) == null ? void 0 : a.id), e;
    }
  },
  watch: {
    currentCanvasId() {
      this.currentCanvasId && this.$el.sequence && this.$el.sequence.setCurrentCanvasId(this.currentCanvasId);
    },
    /* Reload thumbnails when range updates for viewing ranges */
    rangeId_() {
      this.getThumbnails();
    },
    /**
     * Update manifest and current sequence if layout changes
     *
     * @async
     * @param {string} next - The viewer layout type
     */
    async viewerLayout(e, t) {
      const a = this.$el.sequence.currentSequenceIndex, l = this.$el.sequence.sequence[a];
      if (["individuals", "paged"].includes(e)) {
        const i = this.componentType == "sequence" ? this.manifestUrl : this.rangeId_, n = this.$el.vault.get(i);
        if (await this.$el.vault.modifyEntityField(n, "behavior", e), e == "individuals" && t == "gallery" && this.canvasId)
          this.$el.sequence.setCurrentCanvasId(this.currentCanvasId);
        else if (this.$el.sequence.setCurrentCanvasIndex(l[0]), l[0] < 2) {
          let o = {
            detail: {
              total: this.$el.sequence.sequence.length,
              index: l[0]
            }
          };
          this.handleCurrentSequence(o);
        }
      }
    }
  },
  methods: {
    /**
     * Helper for getting child annotations from canvases with annotation pages
     *
     * @param {array} - IIIF canvases
     *
     * @returns {array} - array of IIIF annotation resources
     */
    getAnnotationsFromCanvas(e) {
      let a = this.$el.vault.get(e.items).reduce(
        (l, i) => l.concat(i.items),
        []
      );
      return this.$el.vault.get(a);
    },
    /**
     * Gets thumbnails from items or current range
     *
     * @emits("thumbnailsReady")
     *
     */
    getThumbnails() {
      if (this.manifest) {
        let e = this.componentType == "range" ? this.$el.vault.get(this.rangeId_) : this.manifest;
        e = (e == null ? void 0 : e.items) ?? [];
        const t = this.mapCanvasesToThumbnails(
          e,
          this.labelSource
        );
        this.$emit("thumbnailsReady", t);
      }
    },
    /**
     * Uses the manifest and sequencePosition to generate a title for
     * the HTML canvas
     *
     * @returns {string} - the a11y-title
     */
    buildCanvasTitle() {
      var e;
      if (this.manifest && ((e = this.$el.sequence) != null && e.sequence)) {
        const t = this.currentSequence.map(
          (l) => this.$el.vault.get(this.$el.sequence.items[l].id)
        ), a = this.buildCanvasLabelObjects(t);
        this.canvasTitle = this.buildCanvasLabels(a);
      }
    },
    /**
     * Takes a list of objects with a IIIF canvas and its annotations and returns
     * a list of objects with the labels or alt text for each canvas asset
     *
     * @param {array} - an array of objects with IIIF canvases and their annotations
     *
     * @returns {array} - a list of objects with alt text and/or labels about a
     * IIIF canvas
     *
     */
    buildCanvasLabelObjects(e) {
      let t = [];
      return e.forEach((a) => {
        let l = {
          canvasLabel: this.getLabel(a)
        }, i = this.getRangeByCanvasId(a.id);
        i && (l.rangeLabel = this.getLabel(i));
        let n = this.getAnnotationsFromCanvas(a);
        this.getChoiceAnnotations(n).forEach((s) => {
          let u = this.$el.vault.get(s.body[0]), h = this.$el.vault.get(u.items).map((w) => this.getLabel(this.$el.vault.get(w.id)));
          h.length && (l.choiceLabel = h[0]);
        }), t.push(l);
      }), t;
    },
    /**
     * Takes a list of objects with the descriptive text about a canvas to generate
     * a title for the HTML canvas
     *
     * @param {array} - an array of objects with descriptive texts about a canvas
     *
     * @returns {string} - a string for the title of the HTML canvas
     *
     */
    buildCanvasLabels(e) {
      let t = [];
      if (e.forEach((a) => {
        let l = [];
        for (const [i, n] of Object.entries(a))
          i == "canvasLabel" && l.push(n), i == "rangeLabel" && l.push(n), i == "choiceLabel" && (l = l.concat([`with ${n}`, this.choiceLabel]));
        t.push(l.join(" "));
      }), t.length)
        return t.length == 2 ? `${this.facingPagesLabel}: ` + t.join(" and ") : t[0];
    },
    /**
     * handle sequence update - sets metadata about the currently displayed sequence
     *
     * @async
     * @param {event} e -the event
     *
     */
    async handleCurrentSequence(e) {
      this.sequenceLength = e.detail.total - 1, this.currentChoices = {}, this.sequencePosition = e.detail.index, this.$el.sequence.sequence[this.sequencePosition] == null && (this.sequencePosition = 0, this.$el.sequence.setCurrentCanvasIndex(0));
      let t = this.$el.sequence.sequence[this.sequencePosition];
      this.currentSequence = t, this.buildCanvasTitle();
    },
    /**
     * If the loaded manifest does not have an internal value for "behavior",
     * set to "paged" to enable two-up viewing when first loaded
     *
     * @async
     */
    async initializeBehavior() {
      ["range", "sequence"].includes(this.componentType) && this.manifest && (!this.manifest.behavior || this.manifest.behavior.length == 0) && await this.$el.vault.modifyEntityField(
        this.manifest,
        "behavior",
        "paged"
      );
    }
  }
}, Le = ["manifest-id", "margin", "range-id"], Me = {
  slot: "fallback",
  class: "m-image-viewer__error"
};
function ke(e, t, a, l, i, n) {
  const o = c("ResourceUnavailable");
  return r(), d("sequence-panel", {
    "manifest-id": e.manifestUrl,
    margin: i.sequenceMargin,
    "range-id": n.rangeId_,
    "a11y-role": "img",
    "a11y-title": "facing pages",
    onReadyOnce: t[0] || (t[0] = (...s) => e.handleReady && e.handleReady(...s)),
    onWorldReady: t[1] || (t[1] = (...s) => e.handleWorldReady && e.handleWorldReady(...s)),
    onZoom: t[2] || (t[2] = (...s) => e.handleZoom && e.handleZoom(...s)),
    onSequenceChange: t[3] || (t[3] = (...s) => n.handleCurrentSequence && n.handleCurrentSequence(...s)),
    onSequenceOnce: t[4] || (t[4] = (...s) => n.initializeBehavior && n.initializeBehavior(...s)),
    onMousedown: t[5] || (t[5] = (...s) => e.clickHandler && e.clickHandler(...s)),
    onMouseup: t[6] || (t[6] = (...s) => e.clickHandler && e.clickHandler(...s)),
    onChoice: t[7] || (t[7] = (...s) => e.handleChoice && e.handleChoice(...s)),
    onFullscreenchange: t[8] || (t[8] = (...s) => e.handleNativeFullscreenChange && e.handleNativeFullscreenChange(...s)),
    onContextmenu: t[9] || (t[9] = (...s) => e.handleContextMenu && e.handleContextMenu(...s))
  }, [
    z(e.$slots, "controls", {
      key: i.currentSequence,
      currentChoices: e.currentChoices,
      currentSequence: i.currentSequence,
      numberOfSlides: i.sequenceLength,
      slideIndex: i.sequencePosition
    }),
    f("div", Me, [
      m(o, { "caption-text": e.errorMessage }, null, 8, ["caption-text"])
    ])
  ], 40, Le);
}
const qe = /* @__PURE__ */ v(Te, [["render", ke]]);
const Se = {
  name: "StaticCanvas",
  props: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      default: void 0
    },
    /**
     * The ID of the canvas to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Canvas height
     */
    canvasHeight: {
      type: Number,
      default: void 0
    },
    /**
     * Canvas width
     */
    canvasWidth: {
      type: Number,
      default: void 0
    },
    /**
     * Canvas panel preset
     */
    preset: {
      type: String,
      default: "responsive"
    }
  }
}, Pe = { class: "a-static-canvas" }, Ne = ["manifest-id", "canvas-id", "height", "width", "preset"];
function Re(e, t, a, l, i, n) {
  return r(), d("div", Pe, [
    f("canvas-panel", {
      "manifest-id": a.manifestUrl,
      "canvas-id": a.canvasId,
      height: a.canvasHeight,
      width: a.canvasWidth,
      preset: a.preset
    }, null, 8, Ne)
  ]);
}
const De = /* @__PURE__ */ v(Se, [["render", Re]]);
const Oe = {
  name: "CanvasThumbnail",
  components: {
    ImageResponsive: K,
    ResourceUnavailable: x,
    StaticCanvas: De
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-thumbnail"
    },
    /**
     * Image Responsive or Static Canvas prop object
     */
    thumbnail: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      /**
       * Whether the image is available
       */
      imageAvailable: !0
    };
  },
  methods: {
    /**
     * Handle image responsive component error event
     */
    handleImageError() {
      this.imageAvailable = !1;
    }
  }
}, xe = { class: "a-canvas-thumbnail__wrapper" };
function ze(e, t, a, l, i, n) {
  const o = c("ResourceUnavailable");
  return r(), d("div", xe, [
    i.imageAvailable ? (r(), b(j(a.thumbnail.type), R({
      key: 0,
      class: "a-canvas-thumbnail"
    }, a.thumbnail, { "onImageResponsive:LoadError": n.handleImageError }), {
      default: y(() => [
        k(C(a.thumbnail.caption), 1)
      ]),
      _: 1
    }, 16, ["onImageResponsive:LoadError"])) : (r(), d(q, { key: 1 }, [
      m(o, { class: "" }),
      f("figcaption", null, C(a.thumbnail.caption), 1)
    ], 64))
  ]);
}
const V = /* @__PURE__ */ v(Oe, [["render", ze]]);
const Ee = {
  name: "ImageViewerThumbnailCarousel",
  components: {
    ListingCarousel: $,
    CanvasThumbnail: V
  },
  props: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Array of image responsive or static canvas prop objects
     */
    thumbnailProps: {
      type: Array,
      required: !0
    }
  },
  emits: ["click"],
  setup() {
    ee({ componentRef: le("carousel") });
  }
}, Ze = {
  ref: "carousel",
  class: "m-image-viewer-thumbnails"
}, Ge = ["data-canvas-uuid", "data-canvas-id"];
function Be(e, t, a, l, i, n) {
  const o = c("CanvasThumbnail"), s = c("ListingCarousel");
  return r(), d("div", Ze, [
    m(s, {
      size: "xsmall",
      items: a.thumbnailProps,
      "list-aria-id": "alternate-views"
    }, W({ _: 2 }, [
      a.thumbnailProps ? {
        name: "default",
        fn: y(({ item: u }) => [
          f("button", {
            class: "m-image-viewer-thumbnails__button",
            "data-canvas-uuid": u.id,
            "data-canvas-id": u.canvasId,
            onClick: t[0] || (t[0] = (h) => e.$emit("click", h))
          }, [
            m(o, se(oe({ thumbnail: u })), null, 16)
          ], 8, Ge)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["items"])
  ], 512);
}
const Fe = /* @__PURE__ */ v(Ee, [["render", Be]]);
const Ue = {
  name: "ToolbarMenu",
  components: { GuiButton: P },
  props: {
    /**
     * Menu button name
     */
    name: {
      type: String,
      required: !0
    },
    /**
     * Menu button label
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Currently active menu
     */
    activeMenu: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Whether menu is disabled
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * tooltip label
     */
    tooltip: {
      type: String,
      required: !1,
      default: void 0
    }
  },
  data() {
    return {
      /**
       * If sticky header overlaps tooltip
       */
      isTooltipBelow: !1
    };
  },
  computed: {
    /**
     * Current active classes
     *
     */
    activeMenuClasses() {
      const e = ["a-toolbar-menu"];
      return this.activeMenu == this.name && e.push("a-toolbar-menu--active"), e;
    }
  },
  methods: {
    /**
     * Calculates tooltip position classes based on list item width +
     * left margin and sticky header height
     *
     * @param {object} - mouseenter event
     */
    handleMouseEnter(e) {
      this.isTooltipBelow = e.clientY < 100;
    }
  }
}, je = { class: "a-toolbar-menu__label" }, We = {
  key: 0,
  class: "a-toolbar-menu__options"
};
function _e(e, t, a, l, i, n) {
  const o = c("GuiButton");
  return r(), d("div", {
    class: M(n.activeMenuClasses),
    onMouseenter: t[0] || (t[0] = (...s) => n.handleMouseEnter && n.handleMouseEnter(...s))
  }, [
    m(o, {
      name: a.name,
      modifiers: ["outline", "image-viewer-toolbar"],
      "aria-label": a.label,
      disabled: a.disabled
    }, {
      default: y(() => [
        f("span", je, C(a.label), 1)
      ]),
      _: 1
    }, 8, ["name", "aria-label", "disabled"]),
    a.disabled && a.tooltip ? (r(), d("span", {
      key: 0,
      class: M({
        "a-toolbar-menu__tooltip": !0,
        "a-toolbar-menu__tooltip--below": i.isTooltipBelow
      })
    }, C(a.tooltip), 3)) : g("", !0),
    m(_, { name: "o-image-viewer__fade" }, {
      default: y(() => [
        a.activeMenu == a.name ? (r(), d("div", We, [
          z(e.$slots, "default")
        ])) : g("", !0)
      ]),
      _: 3
    })
  ], 34);
}
const Q = /* @__PURE__ */ v(Ue, [["render", _e]]);
const He = {
  name: "LayoutMenu",
  components: {
    GuiInput: G,
    ToolbarMenu: Q
  },
  inject: {
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String
    },
    /**
     * The available options for the layout menu
     */
    activeLayoutOptions: {
      type: Array,
      default: () => ["individuals", "paged", "gallery"]
    },
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "a-layout-menu"
    },
    /**
     * The current viewer layout for establishing the selected menu value
     */
    currentSelection: {
      type: String,
      default: "paged"
    },
    /**
     * The active menu choice
     */
    activeMenu: {
      type: String,
      default: void 0
    }
  },
  emits: ["layoutChange", "click"],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      /**
       * View layout label
       */
      layoutLabel: this.translate(this.baseLocaleKey + ".layout.default"),
      /**
       * Facing Pages layout option label
       */
      facingPagesLabel: this.translate(this.baseLocaleKey + ".paged"),
      /**
       * Gallery layout option label
       */
      galleryLabel: this.translate(this.baseLocaleKey + ".gallery"),
      /**
       * Single Page layout option label
       */
      singlePageLabel: this.translate(this.baseLocaleKey + ".single_page")
    };
  },
  computed: {
    /**
     * Layout menu options
     * @return {object} - menu options
     */
    options() {
      const e = {
        individuals: this.singlePageLabel,
        paged: this.facingPagesLabel,
        gallery: this.galleryLabel
      };
      return Object.keys(e).reduce((a, l) => (this.activeLayoutOptions.includes(l) && (a[l] = e[l]), a), {});
    }
  },
  methods: {
    /**
     * emits a click event for the menu
     *
     * @param {event} e - the click event
     */
    toggleMenu(e) {
      this.$emit("click", e);
    }
  }
};
function Ye(e, t, a, l, i, n) {
  const o = c("GuiInput"), s = c("ToolbarMenu");
  return r(), b(s, {
    class: "a-layout-menu",
    name: "toggleLayout",
    label: i.layoutLabel,
    "active-menu": a.activeMenu,
    onClick: n.toggleMenu
  }, {
    default: y(() => [
      m(o, {
        name: "layout",
        type: "radio",
        options: n.options,
        value: a.currentSelection,
        onInput: t[0] || (t[0] = (u) => n.toolbarController.handleLayoutChange(u, n.manifestUrl))
      }, null, 8, ["options", "value"])
    ]),
    _: 1
  }, 8, ["label", "active-menu", "onClick"]);
}
const Ve = /* @__PURE__ */ v(He, [["render", Ye]]);
const Qe = {
  name: "SequenceLabels",
  inject: {
    viewerLayout: {
      type: String,
      default: ""
    }
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-toolbar"
    },
    /**
     * Item indexes for current sequence
     */
    currentSequence: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Current range thumbnails
     */
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    }
  },
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  computed: {
    /**
     * Current sequence labels
     */
    currentSequenceLabels() {
      let e = [];
      return this.thumbnailProps.length && (e = this.currentSequence.map((t, a) => {
        let l = this.thumbnailProps[t].concatLabel || this.thumbnailProps[t].caption;
        return this.currentSequence.length > 1 && (l = this.translatePart(a ? "label.right" : "label.left", {
          label: l
        })), l;
      })), e;
    }
  }
};
function Je(e, t, a, l, i, n) {
  return r(), d("div", {
    class: M(`a-sequence-labels a-sequence-labels--${n.viewerLayout}`)
  }, [
    (r(!0), d(q, null, S(n.currentSequenceLabels, (o, s) => (r(), d("div", {
      key: `${s}-${n.viewerLayout}`,
      class: "a-sequence-labels__label"
    }, C(o), 1))), 128))
  ], 2);
}
const Xe = /* @__PURE__ */ v(Qe, [["render", Je]]);
const Ke = {
  name: "ToolbarButton",
  components: {
    GuiButton: P,
    Icon: B
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    name: {
      type: String,
      required: !0
    },
    /**
     * Whether the button is disabled
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * The name of the icon
     */
    iconName: {
      type: String,
      required: !0
    },
    /**
     * The CSS variation
     */
    variation: {
      type: String,
      required: !0
    },
    /**
     * Icon aria title (and tooltip)
     */
    ariaTitle: {
      type: String,
      default: void 0
    },
    /**
     * Icon size
     */
    size: {
      type: Number,
      default: void 0
    }
  },
  emits: ["click"]
};
function $e(e, t, a, l, i, n) {
  const o = c("Icon"), s = c("GuiButton");
  return r(), b(s, {
    name: a.name,
    modifiers: ["icon", "outline", "image-viewer-toolbar"],
    disabled: a.disabled,
    onClick: t[0] || (t[0] = (u) => e.$emit("click"))
  }, {
    default: y(() => [
      m(o, {
        name: a.iconName,
        class: M(`m-image-viewer-toolbar__${a.variation}`),
        "aria-title": a.ariaTitle,
        size: a.size
      }, null, 8, ["name", "class", "aria-title", "size"])
    ]),
    _: 1
  }, 8, ["name", "disabled"]);
}
const et = /* @__PURE__ */ v(Ke, [["render", $e]]), tt = {
  name: "ChoiceMenu",
  components: {
    ToolbarMenu: Q,
    GuiInput: G
  },
  inject: {
    /**
     * The Viewer Layout
     */
    viewerLayout: { type: String },
    /**
     * the Toolbar Controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-toolbar"
    },
    currentChoices: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    activeMenu: {
      type: String,
      default: void 0
    }
  },
  emits: ["click"],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      locale: this.$i18n.locale ?? "en",
      /**
       * Alternate views menu button label
       */
      choiceLabel: this.translate(this.baseLocaleKey + ".choice.default")
    };
  },
  computed: {
    /**
     * Choice tooltip
     * @returns {string} - localized tooltip
     */
    choiceTooltip() {
      let e = `.choice.tooltip.${this.viewerLayout == "gallery" ? "feature_not_available" : "no_alternate_views"}`;
      return this.translate(this.baseLocaleKey + e);
    }
  },
  methods: {
    /**
     * emits a click event for the menu
     *
     * @param {event} e - the click event
     */
    toggleMenu(e) {
      this.$emit("click", e);
    },
    /**
     * GuiInput handler to make choices
     * @param {event} e - GuiInput input event
     */
    handleInput(e) {
      e && this.toolbarController.handleChoice(e);
    },
    /**
     * Get menu mini image
     *
     * @param {string} - choice id image
     * @return {string} - menu thumbnail src url
     */
    getMenuThumbnail(e) {
      return `${e.split("/full")[0]}/full/40,/0/default.jpg`;
    },
    /**
     * Returns props for choice checkbox
     *
     * @param {object} choice - Canvas Panel choice event object
     *
     * @returns {object} GuiInput/FormKit checkbox component props
     */
    getChoiceCheckboxProps(e) {
      let [t, a] = e.items, l = {
        label: N(t, this.locale),
        sectionsSchema: {
          suffix: {
            $el: "img",
            attrs: { src: this.getMenuThumbnail(t.id) }
          }
        },
        onValue: { id: a.id, deselect: !1 },
        offValue: { id: a.id, deselect: !0 }
      };
      return t.selected == !1 && (l.value = { id: a.id, deselect: !1 }), l;
    }
  }
};
function at(e, t, a, l, i, n) {
  const o = c("GuiInput"), s = c("ToolbarMenu");
  return r(), b(s, {
    name: "toggleChoice",
    label: i.choiceLabel,
    tooltip: n.choiceTooltip,
    "active-menu": a.activeMenu,
    disabled: Object.keys(a.currentChoices).length == 0 || n.viewerLayout == "gallery",
    onClick: n.toggleMenu
  }, {
    default: y(() => [
      (r(!0), d(q, null, S(a.currentChoices, (u, h, w) => (r(), b(o, R({
        key: w,
        type: "checkbox",
        ref_for: !0
      }, n.getChoiceCheckboxProps(u), { onInput: n.handleInput }), null, 16, ["onInput"]))), 128))
    ]),
    _: 1
  }, 8, ["label", "tooltip", "active-menu", "disabled", "onClick"]);
}
const nt = /* @__PURE__ */ v(tt, [["render", at]]);
const it = {
  name: "ToolbarGallery",
  components: {
    CanvasThumbnail: V
  },
  props: {
    /* Array of thumbnail component prop objects*/
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Whether to use static canvases (true) or the image service thumbnail property (false) for thumbnails
     */
    useCanvasThumbnails: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {
      /**
       * Intersection Observer instance
       */
      observer: void 0,
      /**
       * Total entries that have intersected
       */
      totalObserved: 0,
      /**
       * Current y position of gallery unordered list
       */
      scrollY: void 0
    };
  },
  mounted() {
    this.initObserver();
  },
  methods: {
    /**
     * Initialize intesection observer on gallery element
     */
    initObserver() {
      const e = document.querySelector(".a-toolbar-gallery__wrapper"), t = e.querySelector(".a-toolbar-gallery__grid");
      this.observer = re(
        new IntersectionObserver((l) => {
          (this.scrollY == null || t.getBoundingClientRect().y < this.scrollY) && (this.totalObserved += l.filter(
            (i) => i.isIntersecting
          ).length), this.scrollY = t.getBoundingClientRect().y;
        })
      );
      const a = e.querySelectorAll("button");
      a.length && a.forEach((l) => {
        this.observer.observe(l);
      });
    }
  }
}, lt = { class: "a-toolbar-gallery" }, st = { class: "a-toolbar-gallery__wrapper" }, ot = { class: "a-toolbar-gallery__grid" }, rt = ["data-canvas-id"];
function ut(e, t, a, l, i, n) {
  const o = c("CanvasThumbnail");
  return r(), d("div", lt, [
    f("div", st, [
      f("div", ot, [
        (r(!0), d(q, null, S(a.thumbnailProps, (s, u) => (r(), d("button", {
          key: u,
          class: "a-toolbar-gallery__thumbnail",
          "data-canvas-id": s.canvasId,
          onClick: t[0] || (t[0] = (h) => e.$emit("click", h))
        }, [
          i.totalObserved && u < i.totalObserved ? (r(), b(o, R({
            key: 0,
            ref_for: !0
          }, { thumbnail: s }), null, 16)) : g("", !0)
        ], 8, rt))), 128))
      ])
    ])
  ]);
}
const ct = /* @__PURE__ */ v(it, [["render", ut]]), E = (e) => {
  const t = te(), a = Z({}), l = Z({});
  function i(o) {
    a.value[o.action] = a.value[o.action] ? a.value[o.action] + 1 : 1;
    let s = !0;
    if (e && (e != null && e[o.action])) {
      const [u, h] = e[o.action];
      (a.value[o.action] <= u || a.value[o.action] > h) && (s = !1);
    }
    s && (n(o), l.value[o.action] = l.value[o.action] ? l.value[o.action] + 1 : 1);
  }
  function n(o) {
    t.emit("ImageViewerInteractionEvent", {
      ...o,
      category: "ImageViewer Interaction",
      noninteraction: !0
    });
  }
  return {
    registerEvent: (o) => i(o),
    emittedEvents: l
  };
};
const dt = {
  name: "ImageViewerToolbar",
  components: {
    GuiButton: P,
    Icon: B,
    LayoutMenu: Ve,
    ToolbarGallery: ct,
    ToolbarButton: et,
    ChoiceMenu: nt,
    SequenceLabels: Xe
  },
  inject: {
    /**
     * Manifest url
     */
    manifestUrl: {
      type: String
    },
    /**
     * Whether full screen is available
     */
    fullscreenAvailable: {
      default: !0,
      type: Boolean
    },
    /**
     * Whether the user can zoom in
     */
    canZoomIn: {
      type: Boolean,
      default: !0
    },
    /**
     * whether the user can zoom out
     */
    canZoomOut: {
      type: Boolean,
      default: !0
    },
    /**
     * whether the viewer is in full-screen mode
     */
    isFullscreen: {
      type: Boolean,
      default: !1
    },
    /**
     * whether this is a sequence or a canvas
     */
    isSequence: {
      type: Boolean,
      default: !1
    },
    /**
     * the viewer layout
     */
    viewerLayout: {
      type: String
    },
    /**
     * The Toolbar controller
     */
    toolbarController: {}
  },
  props: {
    /**
     * The base locale key for the record metadata field component
     **/
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-toolbar"
    },
    /* Current range thumbnails */
    thumbnailProps: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * Whether to show the choice menu
     */
    showChoiceMenu: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * the current choices for the canvas
     */
    currentChoices: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * Item indexes for current sequence
     */
    currentSequence: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The current position in the sequence or set of canvases
     */
    slideIndex: {
      type: Number,
      default: 0
    },
    /**
     * the length of the sequence or # of canvases in the index
     */
    numberOfSlides: {
      type: Number,
      default: 0
    },
    /**
     * Whether or not to enable the rotate button in the toolbar for canvas viewer
     */
    showRotate: {
      type: Boolean,
      default: !1
    },
    /**
     * Download panel canvas details object
     *  {
     *    width: 512,
     *    height: 768,
     *    serviceUrl: URL,
     *  }
     */
    canvasDetails: {
      type: Object,
      default: () => {
      }
    }
  },
  emits: ["hasActiveMenu"],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      analyticsHandler: E(),
      /**
       * Full screen enter aria title
       */
      fullscreenAriaTitle: this.translate(this.baseLocaleKey + ".fullscreen"),
      /**
       * Full screen exit aria title
       */
      fullscreenExitAriaTitle: this.translate(
        this.baseLocaleKey + ".fullscreenExit"
      ),
      /**
       * Active menu button name
       */
      activeMenu: void 0
    };
  },
  computed: {
    /**
     * Whether the user can go backward
     */
    canGoPrevious() {
      return this.slideIndex > 0;
    },
    /**
     * Whether the user can go forward
     */
    canGoNext() {
      return this.numberOfSlides > this.slideIndex;
    },
    /**
     * Is there an activeMenu defined?
     *
     * @returns {boolean}
     */
    hasActiveMenu() {
      return this.activeMenu != null;
    },
    /**
     * The label for the analytics event
     */
    analyticsLabel() {
      var e;
      return this.isSequence ? this.manifestUrl : (e = this.canvasDetails) == null ? void 0 : e.serviceUrl;
    }
  },
  watch: {
    /**
     * when the slide index changes, unset the active menu
     */
    slideIndex() {
      this.activeMenu = void 0;
    },
    /**
     * watch if we have an active menu defined
     */
    hasActiveMenu() {
      this.$parent.$emit("hasActiveMenu", this.hasActiveMenu);
    }
  },
  methods: {
    /**
     * Toggle active controls menu based on click event and button name
     *
     * @param {event} - click event
     */
    toggleMenu(e) {
      e.target.tagName == "BUTTON" && (this.activeMenu == e.target.name ? this.activeMenu = void 0 : this.activeMenu = e.target.name);
    }
  }
}, ht = { class: "m-image-viewer-toolbar__wrapper" }, mt = { class: "m-image-viewer-toolbar" }, ft = { class: "m-image-viewer-toolbar__zoom" }, gt = {
  key: 0,
  class: "m-image-viewer-toolbar__rotate"
}, bt = {
  key: 1,
  class: "m-image-viewer-toolbar__fullscreen"
}, yt = {
  key: 4,
  class: "m-image-viewer-toolbar__sequence"
}, vt = {
  key: 5,
  class: "m-image-viewer-toolbar__fullscreen-close"
};
function Ct(e, t, a, l, i, n) {
  const o = c("ToolbarGallery"), s = c("SequenceLabels"), u = c("ToolbarButton"), h = c("ChoiceMenu"), w = c("LayoutMenu"), A = c("Icon"), D = c("GuiButton");
  return r(), d("div", ht, [
    n.isSequence && n.viewerLayout == "gallery" ? (r(), b(o, {
      key: 0,
      "thumbnail-props": a.thumbnailProps,
      onClick: t[0] || (t[0] = (L) => n.toolbarController.handleGalleryThumbnailClick(L))
    }, null, 8, ["thumbnail-props"])) : g("", !0),
    m(s, {
      "current-sequence": a.currentSequence,
      "thumbnail-props": a.thumbnailProps
    }, null, 8, ["current-sequence", "thumbnail-props"]),
    f("div", mt, [
      f("div", ft, [
        m(u, {
          name: "zoom-in",
          variation: "zoomin",
          disabled: n.canZoomIn == !1 || n.viewerLayout == "gallery",
          "icon-name": "ZoomIn",
          onClick: t[1] || (t[1] = (L) => n.toolbarController.zoomIn(n.analyticsLabel))
        }, null, 8, ["disabled"]),
        m(u, {
          name: "zoom-out",
          variation: "zoomout",
          disabled: n.canZoomOut == !1 || n.viewerLayout == "gallery",
          "icon-name": "ZoomOut",
          onClick: t[2] || (t[2] = (L) => n.toolbarController.zoomOut(n.analyticsLabel))
        }, null, 8, ["disabled"])
      ]),
      a.showRotate ? (r(), d("div", gt, [
        m(u, {
          name: "rotate",
          variation: "rotate",
          "icon-name": "Rotate",
          onClick: t[3] || (t[3] = (L) => n.toolbarController.rotate(n.analyticsLabel))
        })
      ])) : g("", !0),
      n.fullscreenAvailable ? (r(), d("div", bt, [
        m(u, {
          name: "enter-full-screen",
          variation: "full-screen",
          "icon-name": n.isFullscreen ? "FullScreenVideoExit400" : "FullScreenVideo400",
          "aria-title": n.isFullscreen ? i.fullscreenExitAriaTitle : i.fullscreenAriaTitle,
          onClick: t[4] || (t[4] = (L) => n.toolbarController.fullScreenChange(n.analyticsLabel))
        }, null, 8, ["icon-name", "aria-title"])
      ])) : g("", !0),
      a.showChoiceMenu ? (r(), b(h, {
        key: 2,
        "current-choices": a.currentChoices,
        "active-menu": i.activeMenu,
        onClick: n.toggleMenu
      }, null, 8, ["current-choices", "active-menu", "onClick"])) : g("", !0),
      n.isSequence ? (r(), b(w, {
        key: 3,
        "active-menu": i.activeMenu,
        "current-selection": n.viewerLayout,
        onClick: n.toggleMenu
      }, null, 8, ["active-menu", "current-selection", "onClick"])) : g("", !0),
      n.isSequence ? (r(), d("div", yt, [
        m(u, {
          name: "arrow-left",
          variation: "arrowleft",
          "icon-name": "ArrowLeft",
          disabled: !n.canGoPrevious || n.viewerLayout == "gallery",
          onClick: t[5] || (t[5] = (L) => n.toolbarController.previous(n.analyticsLabel))
        }, null, 8, ["disabled"]),
        m(u, {
          name: "arrow-right",
          variation: "arrowright",
          "icon-name": "ArrowRight",
          size: 18,
          disabled: !n.canGoNext || n.viewerLayout == "gallery",
          onClick: t[6] || (t[6] = (L) => n.toolbarController.next(n.analyticsLabel))
        }, null, 8, ["disabled"])
      ])) : g("", !0),
      n.isFullscreen ? (r(), d("div", vt, [
        m(D, {
          name: "close",
          modifiers: ["icon", "outline"],
          onClick: t[7] || (t[7] = (L) => n.toolbarController.fullScreenChange(n.analyticsLabel))
        }, {
          default: y(() => [
            m(A, {
              name: "Close",
              size: 18,
              class: "m-image-viewer-toolbar__close"
            })
          ]),
          _: 1
        })
      ])) : g("", !0)
    ])
  ]);
}
const J = /* @__PURE__ */ v(dt, [["render", Ct]]), wt = "This image is available for free download and may be used for any purpose under Getty's [Open Content Program](https://www.getty.edu/legal/terms-of-use/#open-content-program). Get answers to [Frequently Asked Questions](https://www.getty.edu/about/whatwedo/opencontentfaq.html).", pt = "data:image/png;base64,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";
const At = {
  name: "DownloadMenu",
  components: {
    CopyButton: ae,
    DelimitedFieldValues: ne,
    GuiButton: P,
    GuiLink: F,
    RichText: ie
  },
  props: {
    baseLocaleKey: {
      type: String,
      default: "a-download-menu"
    },
    /**
     * Array of caption fields to populate delimited field values
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * Manifest viewer URL
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Current canvas details
     *  {
     *    width: 512,
     *    height: 768,
     *    serviceUrl: URL,
     *    (optional) sizes: [ {width: 512, height: 768}]
     *  }
     */
    canvasDetails: {
      type: [Object, null],
      required: !0
    },
    /**
     * Max dimensions for download derivatives
     */
    defaultSizes: {
      type: Object,
      default: () => ({
        small: [1024],
        large: [3e3],
        full: []
      })
    },
    /**
     * Manifest viewer base url
     */
    manifestViewerEndpoint: {
      type: String,
      default: "https://tools.getty.edu/iiifviewer/"
    },
    /**
     * Text for the open content permissions description section
     */
    openContentProgramDescription: {
      type: String,
      default: wt
    },
    /**
     * the image url part for parsing a uuid from an image service
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    }
  },
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      /**
       * Whether or not the download menu is toggled
       */
      showMenu: !1,
      /**
       * Image download button
       */
      downloadButtonLabel: this.translatePart("download_button_label", []),
      /**
       * Image download heading
       */
      downloadHeading: this.translatePart("download_heading"),
      /**
       * Mirador link aria label
       */
      miradorLinkAriaLabel: this.translatePart("aria_mirador_link"),
      /**
       * IIIF manifest link
       */
      iiifManifestLinkText: this.translatePart("iiif_manifest"),
      /**
       * IIIF manifest link aria label
       */
      iiifManifestLinkAriaLabel: this.translatePart("aria_iiif_download"),
      /**
       * Open content heading
       */
      openContentHeading: this.translatePart("open_content_heading"),
      /**
       * Caption heading
       */
      captionHeading: this.translatePart("caption_heading"),
      /**
       * Tracks when the copy button is clicked
       */
      isCaptionCopied: !1,
      /**
       * Manifest viewer URL for Rights Panel
       */
      manifestViewerUrl: this.manifestViewerEndpoint ? `${this.manifestViewerEndpoint}?manifest=${this.manifestUrl}` : void 0,
      /**
       * Default size key for the button label dimensions
       */
      defaultSize: "large"
    };
  },
  computed: {
    /**
     * Checks for whether sizes are provided in manifest and returns object
     * for formatting display and url settings for download links
     * @returns {object} { size: [width, height]}
     */
    downloadSizes() {
      let e = this.defaultSizes;
      if (this.canvasDetails.sizes && this.canvasDetails.sizes.length > 3 && this.canvasDetails.sizes[0].width == this.canvasDetails.width && this.canvasDetails.sizes[0].height == this.canvasDetails.height) {
        let t = Object.entries(e).map((a, l) => {
          let i = this.canvasDetails.sizes[3 - l];
          return [a[0], [i.width, i.height]];
        });
        e = Object.fromEntries(t);
      }
      return e;
    },
    /**
     * Array of download link objects
     * @returns {object}
     */
    downloadLinks() {
      let e = {};
      for (let t in this.downloadSizes) {
        const a = this.getDimensions(this.downloadSizes[t]);
        let l = this.translatePart("dimensions", a), i = {
          content: this.translatePart(t) + l,
          dimensions: l,
          ariaLabel: this.translatePart("aria_download_link", {
            dimensions: l
          }),
          href: ve(
            this.canvasDetails.serviceUrl,
            a,
            t,
            this.iiifImageUrlPart
          )
        };
        e[t] = i;
      }
      return e;
    }
  },
  methods: {
    /**
     * Caption string formatted for copy button
     * @returns {string} - caption text
     */
    getCaptionText() {
      let e = "";
      return this.$refs.caption && this.$refs.caption.innerText && (e = this.$refs.caption.innerText.replaceAll(`

`, `
`)), e;
    },
    /**
     * Derives the dimensions of a derivative image based on the original
     * canvas dimensions and a supplied maximum dimension
     *
     * @param {array} dimensions - [?width, ?height]
     *
     * @returns {array} [width, height]
     */
    getDimensions(e) {
      if (e.length !== 2) {
        const t = e[0];
        if (e = [this.canvasDetails.width, this.canvasDetails.height], t && e.every((a) => a > t)) {
          const a = +(e[0] > e[1]), l = +(e[0] < e[1]), i = e[a], n = e[l];
          e = [Math.round(i * t / n)], e.splice(l, 0, t);
        }
      }
      return e;
    },
    /**
     * Handle copied text event
     * @param {event} - copied text event
     */
    handleCopiedText() {
      this.isCaptionCopied = !this.isCaptionCopied, setTimeout(() => {
        this.isCaptionCopied = !this.isCaptionCopied;
      }, 600);
    }
  }
}, It = { class: "a-download-menu__default-link" }, Tt = {
  key: 0,
  class: "a-download-menu__inner"
}, Lt = { class: "a-download-menu__links" }, Mt = { class: "a-download-menu__heading" }, kt = {
  ref: "image-download-links",
  "aria-label": "Image Downloads"
}, qt = { class: "a-download-menu__iiif-link" }, St = ["alt"], Pt = { class: "a-download-menu__permissions" }, Nt = { class: "a-download-menu__heading" }, Rt = {
  key: 0,
  class: "a-download-menu__caption"
}, Dt = { class: "a-download-menu__caption-header" }, Ot = { class: "a-download-menu__heading" };
function xt(e, t, a, l, i, n) {
  const o = c("GuiLink"), s = c("GuiButton"), u = c("RichText"), h = c("CopyButton"), w = c("DelimitedFieldValues");
  return a.canvasDetails ? (r(), d("div", {
    key: 0,
    class: M([
      "a-download-menu",
      {
        "a-download-menu--active": i.showMenu
      }
    ])
  }, [
    f("div", It, [
      a.canvasDetails ? (r(), b(o, {
        key: 0,
        href: n.downloadLinks[i.defaultSize].href,
        "aria-label": n.downloadLinks[i.defaultSize].ariaLabel,
        "with-icon": "before",
        "icon-name": "download500",
        "icon-size": 16,
        download: ""
      }, {
        default: y(() => [
          k(C(i.downloadButtonLabel + n.downloadLinks[i.defaultSize].dimensions), 1)
        ]),
        _: 1
      }, 8, ["href", "aria-label"])) : g("", !0),
      m(s, {
        name: "toggle-download-menu",
        modifiers: ["text"],
        onClick: t[0] || (t[0] = (A) => i.showMenu = !i.showMenu)
      }, {
        default: y(() => t[1] || (t[1] = [
          f("span", null, null, -1)
        ])),
        _: 1,
        __: [1]
      })
    ]),
    m(_, { name: "o-image-viewer__fade" }, {
      default: y(() => [
        i.showMenu ? (r(), d("div", Tt, [
          f("div", Lt, [
            f("div", Mt, C(i.downloadHeading), 1),
            f("ul", kt, [
              (r(!0), d(q, null, S(n.downloadLinks, (A) => (r(), d("li", {
                key: A.size
              }, [
                m(o, {
                  href: A.href,
                  "aria-label": A.ariaLabel,
                  underline: !0,
                  "with-icon": "before",
                  "icon-name": "download",
                  download: ""
                }, {
                  default: y(() => [
                    k(C(A.content), 1)
                  ]),
                  _: 2
                }, 1032, ["href", "aria-label"])
              ]))), 128)),
              f("li", qt, [
                m(o, {
                  href: i.manifestViewerUrl,
                  "aria-label": i.iiifManifestLinkAriaLabel,
                  rel: "nofollow"
                }, {
                  default: y(() => [
                    f("img", {
                      src: pt,
                      class: "iiif-logo",
                      alt: i.miradorLinkAriaLabel
                    }, null, 8, St)
                  ]),
                  _: 1
                }, 8, ["href", "aria-label"]),
                m(o, {
                  id: "download",
                  href: a.manifestUrl,
                  "aria-label": i.iiifManifestLinkAriaLabel,
                  underline: !0,
                  rel: "nofollow"
                }, {
                  default: y(() => [
                    k(C(i.iiifManifestLinkText), 1)
                  ]),
                  _: 1
                }, 8, ["href", "aria-label"])
              ])
            ], 512)
          ]),
          f("div", Pt, [
            f("div", Nt, C(i.openContentHeading), 1),
            m(u, { content: a.openContentProgramDescription }, null, 8, ["content"])
          ]),
          a.captionFields ? (r(), d("div", Rt, [
            f("div", Dt, [
              f("div", Ot, C(i.captionHeading), 1),
              m(h, {
                "text-key": "caption-header",
                text: n.getCaptionText,
                "icon-size": 24,
                onCopiedText: n.handleCopiedText
              }, null, 8, ["text", "onCopiedText"])
            ]),
            f("div", {
              ref: "caption",
              class: M([
                "a-download-menu__caption-content",
                {
                  "a-download-menu__caption-content--disabled": i.isCaptionCopied
                }
              ])
            }, [
              (r(!0), d(q, null, S(a.captionFields, (A, D) => (r(), b(w, {
                key: D,
                values: A,
                delimiter: ", ",
                "data-cy": "openContentCitation"
              }, null, 8, ["values"]))), 128))
            ], 2)
          ])) : g("", !0)
        ])) : g("", !0)
      ]),
      _: 1
    })
  ], 2)) : g("", !0);
}
const zt = /* @__PURE__ */ v(At, [["render", xt]]);
const Et = {
  name: "ImageViewerRightsPanel",
  components: {
    DownloadMenu: zt,
    GuiButton: P,
    GuiLink: F
  },
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer-rights-panel"
    },
    /**
     * Current canvas details
     *  {
     *    width: 512,
     *    height: 768,
     *    serviceUrl: URL,
     *  }
     */
    canvasDetails: {
      type: [Object, null],
      required: !0
    },
    /**
     * Manifest URL
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Additional image data derived from associated visual item
     *    {
     *      isZoomable: false,
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      altText: 'alt text',
     *      descriptiveNote: 'description',
     *      rightsStatementId: 'rightsstatement.org url,
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *    }
     */
    imageDetails: {
      type: Object,
      default: () => {
      }
    },
    /**
     * Array of caption fields to populate delimited field values
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * Whether to show the image request button
     */
    showImageRequestButton: {
      type: Boolean,
      default: !1
    },
    /**
     * the image url part for parsing a uuid from an image service
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    }
  },
  emits: ["imageRequest"],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      imageRequestButtonLabel: this.translatePart("image_request_button_label")
    };
  },
  computed: {
    /**
     * Whether or not the image is part of the open content program
     */
    isOpenContent() {
      var e;
      return this.canvasDetails && this.manifestUrl && ((e = this.imageDetails) == null ? void 0 : e.canDownload);
    },
    /**
     * Rights statement display string
     * @returns {string}
     */
    rightsStatementDisplay() {
      let e = "";
      if (this.imageDetails.rightsStatementId) {
        const t = this.imageDetails.rightsStatementId.split("//")[1], a = Object.entries(I).find(
          (l) => l[1] == t
        );
        e = this.translate(
          this.baseLocaleKey + "." + a[0]
        );
      }
      return e;
    },
    /**
     * Getty UI icon name corresponding to rights statement
     * @returns {string}
     */
    /**
     * The name of the icon to display beside the rights statement
     *
     * @returns {string} the icon name
     */
    rightsIconName() {
      var t;
      let e;
      switch ((t = this.imageDetails) == null ? void 0 : t.rightsStatement) {
        case I.NO_COPYRIGHT:
          e = "CopyrightNone";
          break;
        case I.UNDETERMINED:
        case I.NOT_EVALUATED:
          e = "CopyrightOther";
          break;
        case I.ZERO:
          e = "CC0";
          break;
        case I.IN_COPYRIGHT:
        case I.IN_COPYRIGHT_UNIDENTIFIABLE:
        default:
          e = "Copyright";
          break;
      }
      return e;
    }
  },
  methods: {
    /**
     * Image request button event handler
     */
    handleImageRequest(e) {
      this.$emit("imageRequest");
    }
  }
}, Zt = { class: "m-image-viewer-rights-panel" }, Gt = { class: "m-image-viewer-rights-panel__left" }, Bt = { class: "m-image-viewer-rights-panel__right" }, Ft = {
  key: 0,
  class: "m-image-viewer-rights-panel__copyright"
};
function Ut(e, t, a, l, i, n) {
  var h, w;
  const o = c("DownloadMenu"), s = c("GuiButton"), u = c("GuiLink");
  return r(), d("div", Zt, [
    f("div", Gt, [
      a.canvasDetails && n.isOpenContent ? (r(), b(o, {
        key: 0,
        "caption-fields": a.captionFields,
        "manifest-url": a.manifestUrl,
        "canvas-details": a.canvasDetails,
        "iiif-image-url-part": a.iiifImageUrlPart
      }, null, 8, ["caption-fields", "manifest-url", "canvas-details", "iiif-image-url-part"])) : a.showImageRequestButton ? (r(), b(s, {
        key: 1,
        class: "m-image-viewer-rights-panel__image-request",
        name: "image-request-button",
        modifiers: ["text"],
        onClick: n.handleImageRequest
      }, {
        default: y(() => [
          k(C(i.imageRequestButtonLabel), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : g("", !0)
    ]),
    f("div", Bt, [
      (h = a.imageDetails) != null && h.rightsStatementId ? (r(), d("div", Ft, [
        m(u, {
          ref: "rightsLink",
          href: a.imageDetails.rightsStatementId,
          "with-icon": "before",
          "icon-name": n.rightsIconName,
          class: "m-image-viewer-rights-panel__copyright-link"
        }, {
          default: y(() => [
            k(C(n.rightsStatementDisplay), 1)
          ]),
          _: 1
        }, 8, ["href", "icon-name"]),
        (w = a.imageDetails) != null && w.copyrightStatement ? (r(), d("span", {
          key: 0,
          ref: "copyrightStatement"
        }, C(a.imageDetails.copyrightStatement), 513)) : g("", !0)
      ])) : g("", !0)
    ])
  ]);
}
const jt = /* @__PURE__ */ v(Et, [["render", Ut]]);
class X {
  /**
   * The Toolbar Controller
   *
   * @param {object} wrapper - the wrapper element
   * @param {object} analyticsBus - the analytics bus
   */
  constructor(t, a) {
    this.wrapper = t, this.el = () => {
      var l, i, n;
      return ((i = (l = t.$refs) == null ? void 0 : l.panel) == null ? void 0 : i.$el) ?? ((n = t.$refs) == null ? void 0 : n.panel);
    }, this.analyticsBus = a;
  }
  /**
   * Processes the Zoom In function
   *
   * @param {string} label - the label
   */
  zoomIn(t) {
    this.el().zoomIn(), this.handleAnalyticsEvent("zoom", t);
  }
  /**
   * Processes the Zoom Out function
   *
   * @param {string} label - the label
   */
  zoomOut(t) {
    this.el().zoomOut(), this.handleAnalyticsEvent("zoom", t);
  }
  /**
   * Processes the Rotate function
   *
   * @param {string} label - the label
   */
  rotate(t) {
    this.wrapper.handleRotate(), this.handleAnalyticsEvent("rotate", t);
  }
  /**
   * Processes the FullScreen change function
   *
   * @param {string} label - the label
   */
  fullScreenChange(t) {
    this.wrapper.handleFullscreenChange(), this.handleAnalyticsEvent("full-screen", t);
  }
  /**
   * Processes the previous function
   *
   * @param {string} label - the label
   */
  previous(t) {
    this.el().sequence.previousCanvas(), this.handleAnalyticsEvent("previous-canvas", t);
  }
  /**
   * Processes the next function
   *
   * @param {string} label - the label
   */
  next(t) {
    this.el().sequence.nextCanvas(), this.handleAnalyticsEvent("next-canvas", t);
  }
  /**
   * Processes the Choice event
   *
   * @param {event} e - the choice event
   */
  handleChoice(t) {
    this.el().makeChoice(t.id, {
      deselect: t.deselect,
      deselectOthers: t.deselect
    }), this.handleAnalyticsEvent("choice", t.id);
  }
  /**
   * Handles layout change event
   * @param {event} - viewer layout
   */
  handleLayoutChange(t, a) {
    this.wrapper.setViewerLayout(t), this.handleAnalyticsEvent("layoutChange", a);
  }
  /**
   * Processes the Analytics Event
   *
   * @param {string} type - the type
   * @param {string} label - the label
   */
  handleAnalyticsEvent(t, a) {
    this.analyticsBus.registerEvent({ action: t, label: a });
  }
  /**
   * Handles gallery thumbnail click event
   * @param {event} - click event
   */
  handleGalleryThumbnailClick(t) {
    var a;
    this.wrapper.handleThumbnailClick(t), this.handleAnalyticsEvent("gallery", (a = t.target.dataset) == null ? void 0 : a.canvasId);
  }
}
const Wt = "#000000", _t = {
  name: "ImageViewer",
  components: {
    CanvasViewer: Ie,
    SequenceViewer: qe,
    ImageViewerThumbnailCarousel: Fe,
    ImageViewerToolbar: J,
    ImageViewerRightsPanel: jt
  },
  provide() {
    const e = document.fullscreenEnabled || document.mozFullScreenEnabled || document.documentElement.webkitRequestFullScreen;
    return {
      manifestUrl: this.manifestUrl,
      fullscreenAvailable: e,
      // explicitly provide a computed property
      isSequence: p(() => this.componentName == "SequenceViewer"),
      canZoomIn: p(() => this.canZoomIn),
      canZoomOut: p(() => this.canZoomOut),
      viewerLayout: p(() => this.viewerLayout),
      isFullscreen: p(() => this.isFullscreen),
      toolbarController: p(() => this.toolbarController)
    };
  },
  props: {
    baseLocaleKey: {
      type: String,
      required: !1,
      default: "m-image-viewer"
    },
    /**
     * The manifest url
     */
    manifestUrl: {
      type: String,
      required: !0
    },
    /**
     * Encoded IIIF content state to set on the panel
     */
    contentState: {
      type: String,
      default: void 0
    },
    /**
     * Option for parent to provide canvas id to display
     */
    canvasId: {
      type: String,
      default: void 0
    },
    /**
     * Range id
     */
    rangeId: {
      type: String,
      default: void 0
    },
    /**
     * Which component to render
     */
    componentType: {
      type: String,
      default: "canvas",
      validator(e) {
        if (e)
          return ["canvas", "sequence", "range"].includes(e);
      }
    },
    /**
     * Boolean for whether toolbar should be displayed and zoom enabled (canvas panel only)
     */
    isZoomable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * Whether to render the viewer controls
     */
    hideControls: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Whether to use static canvases (true) or the image service thumbnail property (false) for thumbnails
     */
    useCanvasThumbnails: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * CSS custom property color value to set for both panel and Atlas
     */
    backgroundColor: {
      type: String,
      required: !1,
      default: "#73706e"
    },
    /**
     * Whether to show the choice menu
     */
    showChoiceMenu: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * CSS modifiers
     */
    modifiers: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The available options for the layout menu
     */
    layoutMenuOptions: {
      type: Array,
      required: !1,
      default: () => ["individuals", "paged", "gallery"]
    },
    /**
     * A custom transformation function to enable Bayard
     *
     * @returns {Object}
     *  { type: 'ImageResponsive' | 'StaticCanvas' ... }
     */
    thumbnailRequestTransformer: {
      type: [Function, void 0],
      required: !1,
      default: void 0
    },
    /**
     * Whether to enable the thumbnail carousel
     */
    showThumbnails: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Valid selector of DOM element in parent component
     * (will enable Vue Teleport of provided)
     */
    teleportSelector: {
      type: String,
      default: void 0
    },
    /**
     * Object for providing optional additional data to image derived from visual item (also accepts canvas uuid)
     * { 	"https://media.getty.edu/iiif/image/b3c4fb26-04de-4ac8-9df7-f020f4f97a51":
     *    {
     *      isZoomable: false,
     *      canDownload: false,
     *      copyright: 'copyright statement',
     *      altText: 'alt text',
     *      descriptiveNote: 'description',
     *      rightsStatementId: 'rightsstatement.org url,
     *      disableContextMenu: false,
     *      isDisplayable: false,
     *    }
     * }
     */
    imageMetadata: {
      type: Object,
      default: () => ({})
    },
    /**
     * A delimiting string for parsing uuids from non-Getty IIIF image services
     */
    iiifImageUrlPart: {
      type: String,
      default: void 0
    },
    /**
     * Label behavior for thumbnails, uses thumbnail label by default with options
     * to use the range label or concatenate both
     */
    labelSource: {
      type: String,
      default: "default",
      validator: (e) => ["default", "range", "all"].includes(e)
    },
    /**
     * Whether or not to enable the rotate button in the toolbar for canvas viewer
     */
    showRotate: {
      type: Boolean,
      default: !1
    },
    /**
     * Whether or not to render the rights panel
     */
    showRightsPanel: {
      type: Boolean,
      default: !1
    },
    /**
     * Array of caption fields to populate delimited field values
     *
     * ['value', ['value','value'], { name: 'value', cssClasses: ['css-class'] }]
     */
    captionFields: {
      type: Array,
      default: () => []
    },
    /**
     * Show image request button
     */
    enableImageRequest: {
      type: Boolean,
      default: !1
    },
    /**
     * Return thumbnails only for canvases with associated visual items (canvas panel only)
     */
    filterVisualItems: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "thumbnailsReady",
    "canvasChange",
    "contentStateChange",
    "imageRequest"
  ],
  setup(e) {
    return {
      ...T({
        baseLocaleKey: e == null ? void 0 : e.baseLocaleKey,
        strings: {}
      })
    };
  },
  data() {
    return {
      analyticsHandler: E(),
      toolbarController: void 0,
      locale: this.$i18n.locale ?? "en",
      /**
       * Object of canvas id mapped to thumbnail content resources or canvases
       */
      thumbnails: {},
      /**
       * Timeout id for the reset
       */
      timeoutId: void 0,
      /**
       * the setinterval id for the content state watcher
       */
      contentStateIntervalId: void 0,
      /**
       * current content state
       */
      currentContentState: void 0,
      /**
       * the layout type of the viewer
       */
      viewerLayout: void 0,
      /**
       * Whether the user can zoom in or not
       */
      canZoomIn: this.isZoomable,
      /**
       * whether the user can zoom out or not
       */
      canZoomOut: !1,
      /**
       *  Whether currently in fullscreen or not
       */
      isFullscreen: !1,
      /**
       * Start canvas for when transitioning to fullscreen (sequence panel only)
       */
      startCanvas: this.canvasId,
      /**
       * Disables keyboard when we have an active menu - allows
       * for navigating the menu with the keyboard
       */
      disableKeyboard: !1,
      /**
       * Default thumbnail height
       */
      canvasHeight: 250,
      /**
       * internal boolean for whether current canvas is zoomable (canvas panel only)
       */
      isZoomable_: this.isZoomable,
      /**
       * Local copy of the parent canvas id
       */
      canvasId_: this.canvasId,
      /**
       * Degrees of rotation to apply to the canvas (canvas panel only)
       */
      rotation: 0,
      /**
       * Download panel canvas details object
       *  {
       *    width: 512,
       *    height: 768,
       *    serviceUrl: URL,
       *  }
       */
      canvasDetails: null,
      /**
       * ImageMetadata entry for visual item associated with current canvas
       */
      imageDetails: void 0
    };
  },
  computed: {
    /** Returns component name based on type
     *
     * @returns {string}
     */
    componentName() {
      let e = this.componentType == "range" ? "sequence" : this.componentType;
      return e[0].toUpperCase() + e.slice(1) + "Viewer";
    },
    /**
     * Current background color for both wrapper and Atlas
     *
     * @returns {String} - valid css custom property color value
     */
    panelBackgroundColor() {
      return this.isFullscreen ? Wt : this.backgroundColor;
    },
    /**
     * Classes to apply to parent element
     * @returns {Array} css classes
     */
    classes() {
      let e = ["m-image-viewer"];
      return this.modifiers.forEach((t) => {
        e.push(`m-image-viewer--${t}`);
      }), e;
    },
    /**
     * ImageResponsive or StaticCanvas prop objects based on thumbnails
     * @returns {Array} array of prop objects
     */
    thumbnailProps() {
      let e = Object.entries(this.thumbnails);
      return this.componentType == "canvas" && (e = e.filter(
        ([t, a]) => this.isDisplayable(t, a)
      )), e = e.map((t) => {
        let [a, l] = t;
        if (typeof this.thumbnailRequestTransformer == "function")
          return this.thumbnailRequestTransformer(l);
        if (l.type == "Canvas")
          return {
            type: "StaticCanvas",
            canvasId: l.id,
            canvasHeight: this.canvasHeight,
            preset: "static",
            ...this.getCaptionAndAlt(t)
          };
        if (l.type == "Image")
          return {
            type: "ImageResponsive",
            id: U(l.id, this.iiifImageUrlPart),
            canvasId: l.canvasId,
            size: "post_xsmall_variable_height",
            ...this.getCaptionAndAlt(t)
          };
      }), e;
    }
  },
  watch: {
    contentState() {
      this.setContentState(this.contentState);
    },
    /**
     * Allow parent to update canvas id
     */
    canvasId() {
      this.canvasId_ = this.canvasId;
    }
  },
  mounted() {
    this.toolbarController = new X(this, this.analyticsHandler), this.watchContentState(), this.currentContentState = this.contentState;
  },
  unmounted() {
    clearInterval(this.contentStateIntervalId), clearTimeout(this.timeoutId);
  },
  methods: {
    /**
     * Set current canvas index based on thumbnail click
     */
    handleThumbnailClick(e) {
      var t;
      ((t = e == null ? void 0 : e.target) == null ? void 0 : t.tagName) == "BUTTON" && (this.canvasId_ = e.target.dataset.canvasId), e != null && e.target.classList.contains("a-toolbar-gallery__thumbnail") && (this.viewerLayout = "individuals");
    },
    /**
     * Sets the Viewer layout
     *
     * @param {string} layout
     */
    setViewerLayout(e) {
      this.viewerLayout = e;
    },
    /**
     * Handle Ready event
     * @param {event} e - the ready event
     */
    handleReady(e) {
      this.canZoomIn = this.isZoomable, this.canZoomOut = !1;
    },
    /**
     * Handle World Ready event
     * @param {event} e - the world-ready event
     */
    handleWorldReady(e) {
      this.canZoomIn = this.isZoomable, this.canZoomOut = !1, this.currentContentState == this.contentState && this.setContentState(this.contentState);
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     *
     * sets the 'can zoom in' and 'can-zoom out' logic
     */
    handleZoom(e) {
      this.canZoomIn = e.detail.canZoomIn, this.canZoomOut = e.detail.canZoomOut;
    },
    /**
     * Handle fullscreenchange event and sets isFullscreen
     *
     * @param {event} e - fullscreenchange event
     */
    handleFullscreenChange(e) {
      this.isFullscreen = !this.isFullscreen;
    },
    /**
     * Handle activeMenu event and sets disableKeyboard
     *
     * @param {event} e - fullscreenchange event
     */
    handleActiveMenu(e) {
      this.disableKeyboard = e;
    },
    /**
     * Handle canvas change event (canvas panel only)
     * @param {event} e - canvas change event
     * @emits ImageViewer#canvasChange
     */
    handleCanvasChange(e) {
      var a, l, i;
      const t = this.imageMetadata[(a = e.detail) == null ? void 0 : a.image] || this.imageMetadata[(l = e.detail) == null ? void 0 : l.canvas];
      this.canvasId_ == null && (this.canvasId_ = e.detail.canvas), (i = e.detail) != null && i.canvasDetails && (this.canvasDetails = e.detail.canvasDetails), t && (this.imageDetails = t), (t == null ? void 0 : t.isZoomable) !== void 0 ? this.isZoomable_ = t.isZoomable : this.isZoomable_ != this.isZoomable && (this.isZoomable_ = this.isZoomable), this.$emit("canvasChange", e);
    },
    /**
     * Sets the start canvas to the current sequence canvas id
     * to keep state when entering/exiting fullscreen - sequence panel specific
     */
    setStartCanvas() {
      var t, a;
      let e = (a = (t = this.$refs) == null ? void 0 : t.panel) == null ? void 0 : a.$el;
      if (e && this.componentType != "canvas") {
        let l = e.sequence.currentSequenceIndex, i = e.sequence.sequence[l][0], n = e.sequence.items[i].id;
        this.startCanvas = n;
      }
    },
    /**
     * Listen for interaction events
     *
     * @param {el} element - the dom element to bind the event to
     */
    /**
     * sets the content state on canvas panel
     *
     * @param {contentState} contentState - the string representation of the content state
     */
    setContentState(e) {
      var t, a;
      this.currentContentState = e, (a = (t = this.$refs) == null ? void 0 : t.panel) == null || a.$el.setContentStateFromText(e);
    },
    /**
     * Watches the contentState and emits the content state on a regular interval, sets the current contentState as it changes
     *
     * @emits {contentStateChange} contentStateChange
     *
     */
    watchContentState() {
      this.contentStateIntervalId = setInterval(() => {
        var t, a, l, i, n, o;
        if (((l = (a = (t = this.$refs) == null ? void 0 : t.panel) == null ? void 0 : a.$el) == null ? void 0 : l.getContentState) == null)
          return;
        const e = (n = (i = this.$refs) == null ? void 0 : i.panel) == null ? void 0 : n.$el.getContentState();
        ((o = this.currentContentState) == null ? void 0 : o.encodedContentState) != (e == null ? void 0 : e.encodedContentState) && (this.currentContentState = e, this.$emit("contentStateChange", e));
      }, 1e3);
    },
    /**
     * Boolean whether or not the canvas should be displayed based on
     * image metadata isDisplayable
     *
     * @param {string} - resource id
     *
     * @returns {boolean}
     */
    isDisplayable(e, t) {
      let a = this.imageMetadata[e] || this.imageMetadata[t.canvasId], l = (a == null ? void 0 : a.isDisplayable) ?? !0;
      return this.filterVisualItems ? a ? l : !1 : l;
    },
    /**
     * Returns the caption and alt text props from a canvas id and thumbnail object
     * based on object and additional canvas data from visual item
     *
     * @param {array} - [uuid, thumbnail or canvas object]
     *
     * @returns {object} - caption and alt text entries if available
     */
    getCaptionAndAlt(e) {
      let [t, a] = e, l = N(a, this.locale), i = "", n;
      a.concatLabel && (n = N(
        a,
        this.locale,
        this.translate(this.baseLocaleKey + ".label_delimiter"),
        "concatLabel"
      ));
      const o = this.imageMetadata[t] || this.imageMetadata[a.canvasId];
      o && (i = (o == null ? void 0 : o.altText) ?? i, l = (o == null ? void 0 : o.descriptiveNote) ?? l, i = i == l ? "" : i);
      let s = { caption: l, alt: i };
      return a.concatLabel && (s.concatLabel = n), s;
    },
    /**
     * On rotate event, increments rotation
     */
    handleRotate() {
      this.rotation = this.rotation + 90 === 360 ? 0 : this.rotation + 90;
    }
  }
};
function Ht(e, t, a, l, i, n) {
  const o = c("ImageViewerToolbar"), s = c("ImageViewerRightsPanel"), u = c("ImageViewerThumbnailCarousel");
  return r(), d("div", {
    class: M(n.classes),
    style: H(`--background-color: ${n.panelBackgroundColor};`)
  }, [
    (r(), b(j(n.componentName), R({
      ref: "panel",
      class: "m-image-viewer__panel",
      "skip-sizes": "true",
      responsive: "true"
    }, e.$props, {
      background: n.panelBackgroundColor,
      "viewer-layout": i.viewerLayout,
      "is-fullscreen": i.isFullscreen,
      "active-layout-options": a.layoutMenuOptions,
      "start-canvas": i.startCanvas,
      "disable-keyboard-navigation": i.disableKeyboard,
      "canvas-id": i.canvasId_,
      "is-zoomable": i.isZoomable_,
      "label-source": a.labelSource,
      "ignore-single-finger-touch": "true",
      "enable-pan-on-wait": "false",
      "pan-on-wait-delay": "40",
      "require-meta-key-for-wheel-zoom": "true",
      rotation: i.rotation,
      "use-floor-calc": "true",
      onThumbnailsReady: t[0] || (t[0] = (h) => i.thumbnails = h),
      onCanvasChange: n.handleCanvasChange,
      onZoom: n.handleZoom,
      onReady: n.handleReady,
      onWorldReady: n.handleWorldReady,
      onFullscreenchange: n.handleFullscreenChange,
      onHasActiveMenu: n.handleActiveMenu
    }), W({ _: 2 }, [
      a.hideControls ? void 0 : {
        name: "controls",
        fn: y((h) => [
          i.isZoomable_ || a.componentType != "canvas" ? (r(), b(o, {
            key: 0,
            "current-choices": h.currentChoices,
            "current-sequence": h.currentSequence,
            "thumbnail-props": n.thumbnailProps,
            "is-fullscreen": i.isFullscreen,
            "number-of-slides": h.numberOfSlides,
            "slide-index": h.slideIndex,
            "show-choice-menu": a.showChoiceMenu,
            "show-rotate": a.showRotate,
            "canvas-details": i.canvasDetails
          }, null, 8, ["current-choices", "current-sequence", "thumbnail-props", "is-fullscreen", "number-of-slides", "slide-index", "show-choice-menu", "show-rotate", "canvas-details"])) : g("", !0)
        ]),
        key: "0"
      }
    ]), 1040, ["background", "viewer-layout", "is-fullscreen", "active-layout-options", "start-canvas", "disable-keyboard-navigation", "canvas-id", "is-zoomable", "label-source", "rotation", "onCanvasChange", "onZoom", "onReady", "onWorldReady", "onFullscreenchange", "onHasActiveMenu"])),
    a.componentType == "canvas" && a.showRightsPanel ? (r(), b(s, {
      key: 0,
      "canvas-details": i.canvasDetails,
      "image-details": i.imageDetails,
      "caption-fields": a.captionFields,
      "manifest-url": a.manifestUrl,
      "show-image-request-button": a.enableImageRequest,
      "iiif-image-url-part": a.iiifImageUrlPart,
      onImageRequest: t[1] || (t[1] = (h) => e.$emit("imageRequest", h))
    }, null, 8, ["canvas-details", "image-details", "caption-fields", "manifest-url", "show-image-request-button", "iiif-image-url-part"])) : g("", !0),
    a.componentType == "canvas" && a.showThumbnails && n.thumbnailProps.length ? (r(), b(ue, {
      key: 1,
      disabled: !a.showThumbnails || !a.teleportSelector,
      to: a.teleportSelector
    }, [
      m(u, {
        "manifest-url": a.manifestUrl,
        "thumbnail-props": n.thumbnailProps,
        onClick: n.handleThumbnailClick
      }, null, 8, ["manifest-url", "thumbnail-props", "onClick"])
    ], 8, ["disabled", "to"])) : g("", !0)
  ], 6);
}
const na = /* @__PURE__ */ v(_t, [["render", Ht]]);
const Yt = "#000000", Vt = {
  name: "ImageServiceViewer",
  components: {
    ImageViewerToolbar: J
  },
  provide() {
    return {
      // explicitly provide a computed property
      fullscreenAvailable: document.fullscreenEnabled || document.mozFullScreenEnabled || document.documentElement.webkitRequestFullScreen,
      canZoomIn: p(() => this.canZoomIn),
      canZoomOut: p(() => this.canZoomOut),
      isFullscreen: p(() => this.isFullscreen),
      viewerLayout: void 0,
      toolbarController: p(() => this.toolbarController)
    };
  },
  props: {
    /**
     * CSS custom property color value to set for background
     */
    backgroundColor: {
      type: String,
      required: !1,
      default: "#FFFFFF"
    },
    /**
     * Boolean for whether toolbar should be displayed and zoom enabled
     */
    isZoomable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * CSS modifiers
     */
    modifiers: {
      type: Array,
      required: !1,
      default: () => []
    },
    /**
     * The URL of the image to be displayed
     */
    src: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The region (x,y,width,height) of a specific portion of the image to display
     */
    region: {
      type: [Object, String],
      required: !1,
      default: void 0
    }
  },
  data() {
    return {
      /**
       * the analytics handler
       */
      analyticsHandler: E(),
      /**
       * The toolbar controller
       */
      toolbarController: void 0,
      /**
       * Whether the user can zoom in or not
       */
      canZoomIn: this.isZoomable,
      /**
       * Whether the user can zoom out or not
       */
      canZoomOut: !1,
      /**
       *  Whether currently in fullscreen or not
       */
      isFullscreen: !1
    };
  },
  computed: {
    /**
     * Classes to apply to parent element
     * @returns {Array} css classes
     */
    classes() {
      let e = ["m-image-service-viewer"];
      return this.modifiers.forEach((t) => {
        e.push(`m-image-service-viewer--${t}`);
      }), e;
    },
    /**
     * Checks the region prop to see if it needs to be formatted before passing it into image-service
     *
     * @returns {String|undefined}
     */
    formattedRegion() {
      if (this.region)
        return typeof this.region == "object" ? `${this.region.x},${this.region.y},${this.region.w},${this.region.h}` : this.region;
    },
    /**
     * Background color to use for viewer; switches on fullscreen
     *
     * @returns {String} - valid css custom property color value
     */
    viewerBackgroundColor() {
      return this.isFullscreen ? Yt : this.backgroundColor;
    }
  },
  watch: {
    /**
     * Enter/exit fullscreen
     */
    isFullscreen(e) {
      e == !0 && (this.$el.requestFullscreen || this.$el.webkitRequestFullscreen).call(
        this.$el
      ), document.fullscreenElement && e == !1 && document.exitFullscreen();
    }
  },
  mounted() {
    this.toolbarController = new X(this, this.analyticsHandler);
  },
  methods: {
    /**
     * Handler for toolbar fullscreen change event
     *
     * @param {event} e - fullscreenchange event
     */
    handleFullscreenChange(e) {
      this.isFullscreen = !this.isFullscreen;
    },
    /**
     * Handler for native fullscreenchange events on top level component, like esc to exit fullscreen
     */
    handleNativeFullscreenChange(e) {
      this.isFullscreen && document.fullscreenElement == null && this.handleFullscreenChange(e);
    },
    /**
     * Handle World Ready event - triggers necessary checks
     * @param {event} e - the world-ready event
     */
    handleWorldReady(e) {
      this.handleZoom(e);
    },
    /**
     * Handle the zoom event
     * @param {event} e - the zoom event
     *
     * sets the 'can zoom in' and 'can-zoom out' logic
     */
    handleZoom(e) {
      this.canZoomIn = e.detail.canZoomIn, this.canZoomOut = e.detail.canZoomOut;
    }
  }
}, Qt = ["background", "src", "region", "preset"];
function Jt(e, t, a, l, i, n) {
  const o = c("ImageViewerToolbar");
  return r(), d("div", {
    class: M(n.classes),
    style: H(`--background-color: ${n.viewerBackgroundColor};`),
    onFullscreenchange: t[2] || (t[2] = (...s) => n.handleNativeFullscreenChange && n.handleNativeFullscreenChange(...s))
  }, [
    f("image-service", {
      ref: "panel",
      class: "m-image-service-viewer__canvas",
      background: n.viewerBackgroundColor,
      src: a.src,
      region: n.formattedRegion,
      preset: a.isZoomable ? "zoom" : "static",
      "ignore-single-finger-touch": "true",
      "enable-pan-on-wait": "false",
      "pan-on-wait-delay": "40",
      "require-meta-key-for-wheel-zoom": "true",
      onWorldReady: t[0] || (t[0] = (...s) => n.handleWorldReady && n.handleWorldReady(...s)),
      onZoom: t[1] || (t[1] = (...s) => n.handleZoom && n.handleZoom(...s))
    }, [
      a.isZoomable ? (r(), b(o, { key: 0 })) : g("", !0)
    ], 40, Qt)
  ], 38);
}
const ia = /* @__PURE__ */ v(Vt, [["render", Jt]]), Xt = {
  "m-image-viewer": {
    error_message: "There was an error loading the image (Error: {status})",
    label_delimiter: ", ",
    alt_text: {
      facing_pages: "Facing Pages",
      choice: "that has an alternate view"
    }
  },
  "m-image-viewer-toolbar": {
    choice: {
      default: "Alternate views",
      tooltip: {
        no_alternate_views: "This page does not have any alternate views",
        feature_not_available: "This feature is only available in single and facing pages"
      }
    },
    label: {
      left: "Left: {label}",
      right: "Right: {label}"
    },
    toggle: {
      "aria-open": "Close Menu: {menu}",
      "aria-close": "Open Menu: {menu}"
    },
    fullscreen: "Full Screen",
    fullscreenExit: "Exit Full Screen"
  },
  "a-layout-menu": {
    gallery: "Grid",
    paged: "Facing Pages",
    single_page: "Single Page",
    layout: {
      default: "Layout"
    }
  },
  "a-resource-unavailable": {
    image: {
      alt_text: "Image graphic with strikethrough",
      caption: "Image not available"
    }
  },
  "a-download-menu": {
    dimensions: " ({0} x {1} px)",
    download_button_label: "Download image",
    small: "Presentation/study",
    large: "Large Image",
    full: "Highest Resolution",
    ariaResolution: "Download {resolution}",
    aria_download_link: "Download link for {dimensions} image",
    aria_mirador_link: "Draggable link for IIIF manifest",
    aria_iiif_download: "Download link for IIIF Manifest",
    download_heading: "More downloads",
    caption_heading: "Caption information",
    open_content_heading: "Permission",
    iiif_manifest: "IIIF Manifest"
  },
  "m-image-viewer-rights-panel": {
    image_request_button_label: "Order this image",
    COPYRIGHT_UNIDENTIFIABLE: "In Copyright - Rights-holder(s) unlocatable or unidentifiable",
    IN_COPYRIGHT_UNIDENTIFIABLE: "In Copyright - Rights-holder(s) unlocatable or unidentifiable",
    UNDETERMINED: "Copyright Undetermined",
    COPYRIGHT_UNDETERMINED: "Copyright Undetermined",
    IN_COPYRIGHT: "In Copyright",
    NO_COPYRIGHT: "No Copyright - United States",
    NOT_EVALUATED: "Copyright not evaluated",
    ZERO: "Public Domain"
  }
}, Kt = { en: Xt }, la = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  messages: Kt
}, Symbol.toStringTag, { value: "Module" }));
export {
  ia as ImageServiceViewer,
  na as ImageViewer,
  la as locales
};
